import { useMutation } from '@tanstack/react-query';
import { toast } from 'sonner';
import { IAccount } from '../../../extViewmodels';
import { useUserSession } from '../../../models/hooks/appStateHooks';

export interface IUpdateShareFileFolderLinkRequest {
	accountId: string;
	/** The ShareFile folder URL, or '' to clear it. */
	folderLink: string;
}

/**
 * Sets an account's ShareFile folder link via `PUT admin/account/{id}/additionalInfo/folderLink`.
 * The link is passed as an encoded query param with no body; the updated `IAccount` is returned.
 * Mutations have no MutationCache, so the error toast is wired here explicitly.
 */
export function useUpdateShareFileFolderLinkMutation() {
	const userSession = useUserSession();

	return useMutation({
		mutationFn: (request: IUpdateShareFileFolderLinkRequest) =>
			userSession.webServiceHelper.callAsync<IAccount>(
				`admin/account/${request.accountId}/additionalInfo/folderLink?folderLink=${encodeURIComponent(
					request.folderLink || ''
				)}`,
				'PUT'
			),
		onError: () => toast.error('Failed to update the ShareFile folder link. Please try again.'),
	});
}
